import { fetchAPI } from "../api";



// fetchAPI('/orders/update-status', { orderId: 123, status: 'completed' }, 'POST')
//     .then(response => {
//         console.log('Order status updated:', response);
//     })
//     .catch(error => {
//         console.error('Error updating order status:', error);
//     });

function updateOrderStatus(params) {
    return fetchAPI('/orders/update-status', params, 'POST')
        .then(response => response)
        .catch(error => { throw error });
}

function cancelOrder(params) {
    return fetchAPI('/orders/cancel', params, 'POST')
        .then(response => response)
        .catch(error => { throw error });
}

function completeOrder(params) {
    return fetchAPI('/orders/complete', params, 'POST')
        .then(response => response)
        .catch(error => { throw error });
}

function inProgressOrder(params) {
    return fetchAPI('/orders/in-progress', params, 'POST')
        .then(response => response)
        .catch(error => { throw error });
}

function pendingOrder(params) {
    return fetchAPI('/orders/pending', params, 'POST')
        .then(response => response)
        .catch(error => { throw error });
}

function fetchOrders() {
    return fetchAPI('/orders', {}, 'GET')
        .then(response => response)
        .catch(error => { throw error });
}

function viewOrderDetails(params) {
    return fetchAPI(`/orders/${params.orderId}`, {}, 'GET')
        .then(response => response)
        .catch(error => { throw error });
}

export default {
    updateOrderStatus,
    cancelOrder,
    completeOrder,
    inProgressOrder,
    pendingOrder,
    fetchOrders,
    viewOrderDetails
};